__webpack_require__.p = "https://static.magicsquare.io/_next/";